import StrapiDescription from './StrapiDescription';

export default StrapiDescription;
